import { Box, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import { ContatoKeys, IContato } from "../../../../../../../application/models";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { HeaderFiltro } from "../header-filtro";
import { useProjetosService } from "../../../../../../../use-cases/geo-veles";

export const contatoKeyToLabel = (contactKey: IContato) => {
  switch (contactKey) {
    case 'TELEFONECELULAR':
      return 'Telefone Celular';
    case 'TELEFONEFIXO':
      return 'Telefone Fixo';
    case 'WHATSAPP':
      return 'WhatsApp';
    case 'EMAIL':
      return 'E-mail';
    case 'ENDERECO':
      return 'Endereço';
    default:
      return 'Não definido';
  }
};

export const FiltroContatos = () => {
  // State
  const { filtrosSelecionados } = useAppSelector((state) => state.projetos);
  // Hook
  const { addContatoFilter, removeContatoFilter } = useProjetosService();

  return (
    <>
      <HeaderFiltro
        titulo="Contatos"
        descricao={
          <>
            <Typography style={{ marginBottom: '5px' }}>
              Selecionando as cinco opções (celular, telefone fixo, whatsapp, e-mail e endereço), os filtros serão considerados como obrigatórios na contagem.
            </Typography>
            <Typography style={{ marginBottom: '10px' }}>
              Você pode selecionar quantas opções desejar.
            </Typography>
            <Typography>
              Caso nenhuma das opções seja marcada, nenhuma dessas informações será considerada obrigatória.
            </Typography>
          </>
        }
      />

      <Box p={3}>
        <Grid container spacing={3}>
          {ContatoKeys.map((contactType) => (
            <Grid item xs={6} key={contactType}> {/* Corrigido: key corretamente atribuída */}
              <FormControlLabel
                label={contatoKeyToLabel(contactType).toUpperCase()}
                control={
                  <Switch
                    checked={filtrosSelecionados?.contato?.includes(contactType) ?? false}
                    inputProps={{ 'aria-label': 'controlled' }}
                    onChange={(e) => {
                      if (e.target.checked) {
                        addContatoFilter(contactType);
                      } else {
                        removeContatoFilter(contactType);
                      }
                    }}
                  />
                }
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};
